var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_vm._v("\n    "+_vm._s(_vm.data.name)+"\n\n    "),(!_vm.data.has_child)?_c('vs-button',{staticClass:"ml-4",attrs:{"size":"small","type":"border","color":"warning","icon-pack":"feather","icon":"icon-edit"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }